import { combineReducers } from 'redux'
import companyDashboardReducer from './dashboard/company/reducer'
import companySettingsReducer from './companySettings/reducer'
import comparisonReducer from './industryComparison/reducer'
import competitorComparisonReducer from './competitorComparison/reducer'
import contextCompanyReducer from './company/reducer'
import contextContractReducer from './contract/reducer'
import customReportsReducer from './customReports/reducer'
import filtersReducer from './filters/reducer'
import keyPerformanceIndicatorsReducer from './performanceIndicators/reducer'
import reportsReducer from './reports/reducer'
import subscribedKeyFiguresReducer from './subscribedKeyFigures/reducer'
import valuationAdjustmentsReducer from './valuation/reducer'

const contextReducer = combineReducers({
  company: contextCompanyReducer,
  companyDashboards: companyDashboardReducer,
  companySettings: companySettingsReducer,
  competitorComparison: competitorComparisonReducer,
  contract: contextContractReducer,
  customReports: customReportsReducer,
  filters: filtersReducer,
  industryComparison: comparisonReducer,
  keyPerformanceIndicators: keyPerformanceIndicatorsReducer,
  reports: reportsReducer,
  subscribedKeyFigures: subscribedKeyFiguresReducer,
  valuationAdjustments: valuationAdjustmentsReducer
})

export default contextReducer
